import React from 'react';
import PropTypes from 'prop-types';

import FullPageModal from '@/v2/../components/FullPageModal';
import { GOOGLE_MAPS_KEY } from '@/v2/../config/public';
import GoogleMap from '@/v2/../shared/components/GoogleMap';
import { UI } from '@/v2/types';

interface Props {
  onClose: () => void;
  propertyContent: Pick<UI.Property, 'name' | 'geolocation'>;
}

const Map = ({ propertyContent, onClose }: Props) => {
  return (
    <FullPageModal onClose={onClose}>
      <FullPageModal.Header>{propertyContent.name}</FullPageModal.Header>
      {/* @ts-ignore TS on `next build` struggles to infer that Body takes children as a prop */}
      <FullPageModal.Body>
        <GoogleMap
          apiKey={GOOGLE_MAPS_KEY || ''}
          center={propertyContent.geolocation}
          pins={[
            {
              ...propertyContent.geolocation,
              title: propertyContent.name,
            },
          ]}
          zoom={15}
        />
      </FullPageModal.Body>
    </FullPageModal>
  );
};

Map.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Map;
